import { Stack } from "@mui/material";
import { ClaudeIcon } from "@src/images/Icons/integrations/ClaudeIcon";
import { OpenAIIcon } from "@src/images/Icons/integrations/OpenAIIcon";
import { SlackIcon } from "@src/images/Icons/integrations/SlackIcon";

const ICON_SIZE = 16;

export const IntegrationsNavLogos = () => (
  <Stack
    aria-hidden="true"
    direction="row"
    spacing={1}
    sx={{
      alignItems: "center",
      flexShrink: 0,
      pointerEvents: "none",
    }}
  >
    <ClaudeIcon sx={{ fontSize: ICON_SIZE }} />
    <SlackIcon sx={{ fontSize: ICON_SIZE }} />
    <OpenAIIcon sx={{ fontSize: ICON_SIZE }} />
  </Stack>
);
